import React, { useState } from "react";
import { Global } from "../helpers/Global";

export const CrearCliente = () => {
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const agregarCliente = async (e) => {
    e.preventDefault();
    setMensaje("");
    setError("");

    if (!nombre.trim() || !codigo.trim()) {
      setError("❌ Debes indicar el nombre y el código del cliente");
      return;
    }

    try {
      const response = await fetch(Global.url + "clientes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ nombre: nombre.trim(), codigo: codigo.trim() }),
      });

      const data = await response.json();

      if (response.ok) {
        setNombre("");
        setCodigo("");
        setMensaje("✅ Cliente añadido correctamente");
        setTimeout(() => setMensaje(""), 3000);
      } else {
        setError(data.message || "❌ Error al añadir el cliente");
      }
    } catch (error) {
      console.error("Error al añadir cliente:", error);
      setError("❌ Error inesperado al añadir el cliente");
    }
  };

  return (
    <div className="form-crear-usuario">
      <h2>Registrar Cliente</h2>

      {(mensaje || error) && (
        <p className={`mensaje ${error ? "rojo" : "verde"}`}>
          {error || mensaje}
        </p>
      )}

      <form onSubmit={agregarCliente} className="formulario-usuario">
        <div className="form-group">
          <label>Nombre del cliente:</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Código del cliente:</label>
          <input
            type="text"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            required
          />
        </div>

        <button className="btn-login" type="submit">
          Guardar Cliente
        </button>
      </form>
    </div>
  );
};
